module.exports = __webpack_public_path__ + "static/founder-1-9f5afd8bed8a99982f1d90c8f48418cb.png";